import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meeting-title-dialog',
  templateUrl: './meeting-title-dialog.component.html',
  styleUrls: ['./meeting-title-dialog.component.css']
})
export class MeetingTitleDialogComponent implements OnInit {

  options: any
  optionsTwo: any
  today : any
  currentDate : any
  currentDateTwo : any
  constructor() { }

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';

  ngOnInit(): void {
    this.optionsTwo = {
      weekday : 'long',
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
    this.today = new Date();
    this.currentDateTwo = this.today.toLocaleDateString("en-US",this.optionsTwo)
  }

}
